import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

export default function AdminDashboard() {
  const { getIdToken } = useAuth();
  const [stats, setStats] = useState({ users: 0, prs: 0, packages: 0, transactions: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getIdToken();
    const h = { Authorization: `Bearer ${token}` };
    Promise.all([
      axios.get(`${API_URL}/api/users.json`, { headers: h }).catch(() => ({ data: { users: [] } })),
      axios.get(`${API_URL}/api/press-releases.json`).catch(() => ({ data: { pressReleases: [] } })),
      axios.get(`${API_URL}/api/packages.json`).catch(() => ({ data: { packages: [] } })),
      axios.get(`${API_URL}/api/transactions.json`, { headers: h }).catch(() => ({ data: { transactions: [] } })),
    ]).then(([uRes, prRes, pkgRes, txRes]) => {
      setStats({
        users:        (uRes.data.users || []).length,
        prs:          (prRes.data.pressReleases || []).length,
        packages:     (pkgRes.data.packages || []).length,
        transactions: (txRes.data.transactions || []).length,
      });
      setLoading(false);
    });
  }, [getIdToken]);

  return (
    <div>
      <h2 style={s.pageTitle}>Admin Dashboard</h2>
      <p style={s.subtitle}>Platform overview and management.</p>

      {loading ? (
        <div style={s.loading}>Loading stats...</div>
      ) : (
        <div style={s.statsGrid}>
          <StatCard label="Total Users"          value={stats.users}        icon="👥" color="#1565c0" to="/admin/users" />
          <StatCard label="Press Releases"       value={stats.prs}          icon="📰" color="#e94560" to="/admin/press-releases" />
          <StatCard label="Active Packages"      value={stats.packages}     icon="📦" color="#0d8c6d" to="/admin/packages/pr" />
          <StatCard label="Transactions"         value={stats.transactions} icon="💳" color="#7c3aed" to="/admin/packages/pr" />
        </div>
      )}

      <div style={s.quickGrid}>
        <AdminLink to="/admin/users"          icon="👥" label="Manage Users" />
        <AdminLink to="/admin/packages/pr"    icon="📦" label="PR Packages" />
        <AdminLink to="/admin/packages/guest" icon="📦" label="Guest Packages" />
        <AdminLink to="/admin/press-releases" icon="📰" label="Review PRs" />
        <AdminLink to="/admin/guest-posts"    icon="✍"  label="Review Guest Posts" />
      </div>
    </div>
  );
}

function StatCard({ label, value, icon, color, to }) {
  return (
    <Link to={to} style={{ ...s.statCard, borderTop: `3px solid ${color}`, textDecoration: 'none' }}>
      <div style={s.statIcon}>{icon}</div>
      <div>
        <div style={{ ...s.statValue, color }}>{value}</div>
        <div style={s.statLabel}>{label}</div>
      </div>
    </Link>
  );
}

function AdminLink({ to, icon, label }) {
  return (
    <Link to={to} style={s.adminLink}>
      <span style={s.alIcon}>{icon}</span>
      <span style={s.alLabel}>{label}</span>
    </Link>
  );
}

const s = {
  pageTitle: { margin: '0 0 0.25rem', fontSize: '1.6rem', fontWeight: 700, color: '#1a1a2e' },
  subtitle: { margin: '0 0 1.75rem', color: '#666', fontSize: '0.9rem' },
  loading: { textAlign: 'center', padding: '3rem', color: '#888' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(200px,1fr))', gap: '1rem', marginBottom: '2rem' },
  statCard: { background: '#fff', borderRadius: 8, padding: '1.25rem', display: 'flex', alignItems: 'center', gap: '1rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', color: 'inherit' },
  statIcon: { fontSize: '2rem' },
  statValue: { fontSize: '1.8rem', fontWeight: 700 },
  statLabel: { fontSize: '0.82rem', color: '#888', marginTop: 2 },
  quickGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(150px,1fr))', gap: '1rem', background: '#fff', borderRadius: 8, padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  adminLink: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', padding: '1.25rem 0.5rem', background: '#f8f9fa', borderRadius: 8, textDecoration: 'none', color: '#1a1a2e', border: '1px solid #eee', fontSize: '0.875rem', fontWeight: 600 },
  alIcon: { fontSize: '1.5rem' },
  alLabel: { textAlign: 'center', lineHeight: 1.3 },
};
